import { Phone } from "lucide-react";

const FinalCta = () => (
  <section className="bg-[#FFD400] py-16 md:py-24">
    <div className="container text-center max-w-2xl">
      <h2 className="text-3xl md:text-4xl font-black text-[#111111] leading-tight mb-3">
        Ready For A Cleaner Space?
      </h2>
      <p className="text-[#111111]/80 text-base mb-10">
        Fast quotes and reliable cleaning services.
      </p>
      <div className="flex flex-col sm:flex-row gap-4 justify-center">
        <a
          href="#quote"
          className="bg-[#0066FF] text-white px-8 py-4 text-lg font-bold rounded-md hover:bg-[#0066FF]/90 transition-colors text-center shadow-[0_4px_14px_rgba(0,102,255,0.3)]"
        >
          Get Free Quote
        </a>
        <a
          href="tel:1300000000"
          className="flex items-center justify-center gap-2 border-2 border-[#111111] text-[#111111] px-8 py-4 text-lg font-bold rounded-md hover:bg-[#111111]/5 transition-colors text-center"
        >
          <Phone className="w-5 h-5" />
          Call Now
        </a>
      </div>
    </div>
  </section>
);

export default FinalCta;
